<template>
  <div>
    <FormLabel style="margin-bottom: 5px">I Want to Support</FormLabel>

    <FormRow class="designation" inline>
      <FormSelect field="applications.0.campaign">
        <option selected="selected" value="General Donation">NCSY</option>
        <option value="JSU Donation">JSU</option>
        <option value="Latte & Learning">Latte and Learning</option>
        <option value="Scholarships">Summer Programs Scholarships</option>
        <option value="NCSY Connect">NCSY Connect - Campaign 18</option>
        <option value="JSU Expansion">JSU Expansion</option>
      </FormSelect>
    </FormRow>

    <FormLabel style="margin-bottom: 5px">Chapter</FormLabel>
    <FormRow class="designation" inline>
      <FormSelect field="applications.0.department" :showLabel="false">
        <option selected="selected" value="NCSY_WestCoast">General</option>
        <option value="NCSY_SanDiego">San Diego</option>
        <option value="NCSY_Seattle">Seattle</option>
        <option value="NCSY_Arizona">Arizona</option>
        <option value="NCSY_OrangeCounty">Orange County</option>
        <option value="NCSY_Norcal">Norcal</option>
        <option value="NCSY_ParkCityUtah">NCSY Park City Utah</option>
        <option value="NCSY_LasVegas">NCSY Las Vegas</option>
        <option value="NCSY_LAValley">NCSY LA Valley</option>
        <option value="NCSY_LACity">NCSY LA City</option>
        <!-- <option value="NCSY_LACity">israel eduction goes to (NCSY West Coast - Israel Education)</option> -->
      </FormSelect>
    </FormRow>

    <FormRow class="designation" inline v-if="filtersOpen">
      <FormSelect field="applications.0.campaign">
        <option selected="selected" value="NCSY">NCSY</option>
        <option value="JSU">JSU</option>
        <option value="Latte and Learning">Latte and Learning</option>
        <option value="Summer Programs Scholarships">Summer Programs Scholarships</option>
        <option value="NCSY Connect - Campaign 18">NCSY Connect - Campaign 18</option>
      </FormSelect>
      <ErrorLabel field="applications.0.campaign" style="text-align: right" />
    </FormRow>

    <FormRow class="designation" inline v-if="filtersOpen">
      <div class="styled-dropdown__container">
        <ul class="styled-dropdown__list">
          <li class="active" @click="filtersOpen = !filtersOpen">
            <label>
              <input type="radio" name="departments" value="NCSY" />
              <img
                src="https://res.cloudinary.com/ncsy/image/fetch/https://api.ncsy.org/eventimage/198384?v=5b0a6125a3fd8"
                alt="NCSY"
                class="styled-dropdown__item-img"
              />
              <div>
                <span class="styled-dropdown__item-name">NCSY</span>
                <span class="styled-dropdown__item-desc"></span>
              </div>
            </label>
          </li>
          <li class="">
            <label>
              <input type="radio" name="departments" value="JSU" />
              <img
                src="https://res.cloudinary.com/ncsy/image/fetch/https://api.ncsy.org/eventimage/201531?v=5adf34bf6d501"
                alt="JSU"
                class="styled-dropdown__item-img"
              />
              <div>
                <span class="styled-dropdown__item-name">JSU</span>
                <span class="styled-dropdown__item-desc"></span>
              </div>
            </label>
          </li>
          <li class="">
            <label>
              <input type="radio" name="departments" value="Latte and Learning" />
              <img
                src="https://res-1.cloudinary.com/ncsy/image/fetch/c_fit,f_auto,h_140,w_170/https://api.ncsy.org/eventimage/199342%3Fv%3D5b0abdd003a8d"
                alt="L&amp;L"
                class="styled-dropdown__item-img"
              />
              <div>
                <span class="styled-dropdown__item-name">Latte and Learning</span>
                <span class="styled-dropdown__item-desc"></span>
              </div>
            </label>
          </li>
          <li class="">
            <label>
              <input type="radio" name="departments" value="Summer Programs" />
              <img
                src="https://ncsy.org/assets/Summer-programs-230x220.jpg"
                alt="Summer"
                class="styled-dropdown__item-img"
              />
              <div>
                <span class="styled-dropdown__item-name"
                  >Summer Programs Scholarships</span
                >
                <span class="styled-dropdown__item-desc"></span>
              </div>
            </label>
          </li>
          <li class="">
            <label>
              <input type="radio" name="departments" value="NCSY Connect 18" />
              <img
                src="https://westcoast.ncsy.org/files/2-300x200.png"
                alt="Connect"
                class="styled-dropdown__item-img"
              />
              <div>
                <span class="styled-dropdown__item-name">NCSY Connect - Campaign 18</span>
                <span class="styled-dropdown__item-desc"></span>
              </div>
            </label>
          </li>
        </ul>
        <span class="styled-dropdown__handle" style=""
          ><i>
            <svg viewBox="0 0 320 512">
              <path
                d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
              /></svg></i
        ></span>
      </div>
    </FormRow>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    let filtersOpen = ref(false);
    const { getValue } = usePaymentForm();

    return {
      getValue,
      filtersOpen,
    };
  },
});
</script>
<style scoped lang="scss">
.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width: 50%;
    max-width: 50%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}

.styled-dropdown__container {
  margin-top: 10px;
  transition: all 0.3s ease-in-out;
  min-height: 60px;
  position: relative;
  padding: 0px !important;
  border-bottom: 1px solid #ddd;
}
ul.styled-dropdown__list {
  padding-left: 0;
  list-style: none;
  background: #ffffff;
  border: 1px solid #ddd;
  border-bottom: none;
  margin-bottom: 0;
}
.styled-dropdown__list li {
  padding: 10px 20px;
  overflow: hidden;
  min-height: 60px;
  display: none;
  &.active {
    display: block;
  }
  label {
    display: flex;
    align-items: center;
    margin-bottom: 0;
    cursor: pointer;
  }
  input[type="radio"] {
    position: absolute;
    left: -9999px;
    margin: 4px 0 0;
    margin-top: 1px \9;
    line-height: normal;
  }
}
.styled-dropdown__item-img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  margin-right: 20px;
}

.styled-dropdown__item-name {
  color: #333;
  font-weight: 400;
}

.styled-dropdown__item-desc {
  display: block;
  font-weight: 100;
  font-size: 12px;
  color: #666;
  margin-top: 3px;
}
.styled-dropdown__handle {
  position: absolute;
  top: 0;
  right: 0;
  height: 60px;
  width: 100%;
  padding-right: 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  i {
    width: 10px;
    height: 16px;
  }
}
</style>
